// extracted by mini-css-extract-plugin
module.exports = {"checkboxesContainer":"CreateEditClinics_checkboxesContainer__1BHe9","emails":"CreateEditClinics_emails__2TggX","emailTagLabel":"CreateEditClinics_emailTagLabel__bZghe"};